import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { HistoryOrderItem } from '@df/session/api/history/history-order-item';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Nexus } from '@tomandco/nexus-api-types';
@Component({
    selector: 'checkout-success-item',
    templateUrl: './checkout-success-item.html',
    standalone: true,
    imports: [SizeClassDirective, ImageModule, PriceComponent, OptionLabelPipe, TranslationModule, ShellComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.Default
})
export class CheckoutSuccessItemComponent extends ProductComponentDef {
    @Input({
        required: true
    })
    item!: Nexus.Lib.Customer.Order.HistoryOrderItem;

    get image(): string | undefined {
        return this.item.am_giftcard_image_url || this.model?.data?.image;
    }

    get rewardPoints(): number | undefined {
        const rewardPoints = this.item.reward_points;
        if (!rewardPoints) {
            return undefined;
        }
        return rewardPoints * this.item.qty_ordered;
    }
}
